import React from "react";
import { QqControlsGroupPropsType } from "./qq-controls-group-props.type";
import { QqControlFactoryRaw } from "./qq-control-factory.raw";

export const QqControlsGroupOpenControlRaw: React.FunctionComponent<QqControlsGroupPropsType> =
  ({ group, dispatch, state }) => {
      const ctrlFactory = new QqControlFactoryRaw();
      const controls = group.qq.map((qq) =>
      ctrlFactory.create({ state, dispatch }, qq)
    );
    return (
      <fieldset>
        {group.label && <legend>{group.label}</legend>}
        {controls}
      </fieldset>
    );
  };
